import { render, staticRenderFns } from "./ListaPromocoes.vue?vue&type=template&id=53fcfcd4&scoped=true"
import script from "./ListaPromocoes.vue?vue&type=script&lang=js"
export * from "./ListaPromocoes.vue?vue&type=script&lang=js"
import style0 from "@/components/regras/regra-modal.css?vue&type=style&index=0&id=53fcfcd4&prod&scoped=true&lang=css&external"
import style1 from "./ListaPromocoes.vue?vue&type=style&index=1&id=53fcfcd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fcfcd4",
  null
  
)

export default component.exports